module.exports = __webpack_public_path__ + "img/claude-ico.808d95e6.svg";